export default "__VITE_ASSET__CUg2ZWKj__"